class DicoChimie {

    constructor() {
        this.container = document.querySelector('.post-type-archive-dico');
        if (!this.container) return;

        this.searchBar = this.container.querySelector(".search-bar input");
        if (!this.searchBar) return;

        this.initFilters();
        this.initEls();
        this.initEvents();

        this.collapses = this.container.querySelectorAll(".dico-item");
        if (!this.collapse) return;

        this.collapse();
        resizeCallbacks.push(this);
    }

    initFilters() {
        this.allLetters = this.container.querySelectorAll('.dico-letter');
        this.allArticles = this.container.querySelectorAll('.dico-item');
        this.noResult = this.container.querySelector('.no-result');
        this.filterLetters = this.container.querySelectorAll('#filterLetter li');
        this.filterCat = this.container.querySelectorAll('#filterCat li');

        this.currentLetter = 'all';
        this.currentCat = 'all';

        this.filterLetters.forEach(letter => {
            letter.addEventListener('click', () => {
                this.filterLetters.forEach(letter => {
                    letter.classList.remove('active');
                });
                this.currentLetter = letter.dataset.letterTrigger;
                letter.classList.add('active');
                this.filter();
            });
        });

        this.filterCat.forEach(cat => {
            cat.addEventListener('click', () => {
                this.filterCat.forEach(cat => {
                    cat.classList.remove('active');
                });
                this.currentCat = cat.dataset.catTrigger;
                cat.classList.add('active');
                this.filter();
            });
        });
    }

    filter() {

        let allHidden = true;

        this.allLetters.forEach(letter => {
            letter.classList.add('hidden');
        });

        this.allArticles.forEach(article => {
            article.classList.add('hidden');
            let visible = false;

            if (this.currentLetter === 'all' && this.currentCat === 'all') {
                visible = true;
            }

            if (this.currentLetter === 'all' && this.currentCat === article.dataset.category) {
                visible = true;
            }

            if (this.currentLetter.split(';').includes(article.dataset.letter) && this.currentCat === article.dataset.category) {
                visible = true;
            }

            if (this.currentLetter.split(';').includes(article.dataset.letter) && this.currentCat === "all") {
                visible = true;
            }

            if (visible) {
                allHidden = false;
                article.classList.remove('hidden');
                this.allLetters.forEach(letter => {
                    if (letter.dataset.letter === article.dataset.letter) {
                        letter.classList.remove('hidden');
                    }
                });
            }
        });

        if (allHidden) {
            this.noResult.classList.remove('hidden');
        } else {
            this.noResult.classList.add('hidden');
        }
    }

    resetFilters() {
        this.filterLetters[0].click();
        this.filterCat[0].click();
    }

    initEls() {
        this.resultsContainer = this.container.querySelector(".search-results");
        this.resultsList = this.resultsContainer.querySelector("ul");
        this.articles = articleList;
        this.currentFocus = 0;
    }

    initEvents() {
        this.searchBar.previousValue = this.searchBar.value.trim().toLowerCase();

        this.searchBar.addEventListener("keyup", e => {
            const results = this.resultsList.querySelectorAll(".word");

            switch (e.keyCode) {
                // arrow up
                case 38:
                    this.currentFocus--;
                    this.addActive(results);
                    return;

                // arrow down
                case 40:
                    this.currentFocus++;
                    this.addActive(results);
                    return;

                // enter
                case 13:
                    this.resetFilters();
                    if (results[this.currentFocus]) {
                        results[this.currentFocus].click();
                    }
                    return;
            }

            const query = e.target.value.trim().toLowerCase();

            if (query === this.searchBar.previousValue) {
                return;
            }
            this.searchBar.previousValue = query;

            this.search(query);
        });

        this.searchBar.addEventListener("blur", () => {
            setTimeout(() => {
                this.closeSearchResults(true);
            }, 250);
        });
    }

    /**
     * @param {string} query - Le mot clé à utiliser pour la recherche.
     * @param {number} [limit=5] - Le nombre maximum de résultats à afficher.
     * @param {number} [minChars=3] - Le nombre de caractères minimal à partir duquel effectuer la recherche.
     */
    search(query, limit = 5, minChars = 1) {
        let searchResults = [];

        if (query !== "" && query.length >= minChars) {
            this.articles.forEach(article => {

                const sanitizedName = this.sanitizeString(article.name);
                const sanitizedQuery = this.sanitizeString(query);

                if (sanitizedName.includes(sanitizedQuery)) {
                    return searchResults.push(article);
                }
            });
        }

        if (searchResults.length > limit) {
            searchResults = searchResults.slice(limit - 1);
        } else if (searchResults.length === 0) {
            searchResults = null;
        }

        this.renderResults(searchResults);
    }

    closeSearchResults(clearInput = false) {
        if (clearInput) {
            this.searchBar.value = "";
        }
        this.resultsList.innerHTML = "";
        this.resultsList.setAttribute("aria-expanded", "false");
    }

    renderResults(searchResults) {

        if (!searchResults) {
            return this.closeSearchResults();
        }

        let list = "";
        searchResults.forEach(article => {
            list += `
				<li>
					<a href="#${article.slug}" class="word">
						<span class="word-main">${article.name}</span>
						<span class="word-extract">${article.extract}</span>
						
					</a>
				</li>
			`;
        });
        this.resultsList.setAttribute("aria-expanded", "true");
        this.resultsList.innerHTML = list;

        this.addActive(this.resultsList.querySelectorAll(".word"));
    }

    /**
     * Ajouter la classe autocomplétion au résultat de la recherche en fonction du focus actuel
     * @param {Array} results
     */
    addActive(results) {
        this.removeActive(results);

        if (this.currentFocus >= results.length) {
            this.currentFocus = 0;
        } else if (this.currentFocus < 0) {
            this.currentFocus = results.length - 1;
        }
        results[this.currentFocus].classList.add("autocomplete-active");
    }

    /**
     * Enlever la classe d'autocomplétion de tous les résultats
     * @param {Array} results
     */
    removeActive(results) {
        results.forEach(result => {
            result.classList.remove("autocomplete-active");
        });
    }

    // Pas idéal, mais fait le taff
    sanitizeString(str) {
        str = str.toLowerCase();
        // str.normalize('NFD').replace(/\p{Diacritic}/gu, "");

        str = str.replace(/[àâä]/gim, "a");
        str = str.replace(/[éèêë]/gim, "e");
        str = str.replace(/[ìîï]/gim, "i");
        str = str.replace(/[òôö]/gim, "o");
        str = str.replace(/[ùûü]/gim, "u");

        return str.trim();
    }

    collapse() {
        this.collapses.forEach(collapse => {
            const head = collapse.querySelector(".collapse-head");
            const body = collapse.querySelector(".dico-description");
            body.dataset.height = body.clientHeight;
            body.style.height = 0;
            head.addEventListener("click", () => {
                if (collapse.classList.contains("open")) {
                    collapse.classList.remove("open");
                    gsap.to(body, {
                        height: 0,
                        duration: 0.3
                    });
                } else {
                    collapse.classList.add("open");
                    gsap.to(body, {
                        height: body.dataset.height,
                        duration: 0.3
                    });
                }
            });
        });
    }

    resize() {
        this.collapses.forEach(collapse => {
            const body = collapse.querySelector(".dico-description");
            body.style.height = "auto";
            body.dataset.height = body.clientHeight;
            if (!collapse.classList.contains("open")) {
                body.style.height = 0;
            }
        });
    }
}